import React, {useEffect} from 'react'
import {PageHeader} from "../../../components/common/pageHeader/PageHeader";
import {Pagination} from "../../../components/common/pagination/Pagination";
import {useNavigate, useSearchParams} from "react-router-dom";
import {URL_COURSES_CREATE} from "../../../mock/page_urls";
import {useQuery} from "react-query";
import {LoaderSection} from "../../../components/sections/loader/Loader";
import {EmptySection} from "../../../components/sections/empty/Empty";
import {separateFormatter} from "../../../utils/separateFormatter";
import {KTIcon, useDebounce} from "../../../../_metronic/helpers";
import {getCourses} from "../../../services/courseSvc";
import {CourseCard} from "../../../components/common/courseCard/CourseCard";

export const CoursesPage = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const page = parseInt(searchParams.get("page") || "1", 10)
  const searchQuery = searchParams.get("search") || ""

  const debouncedSearch = useDebounce(searchQuery, 500);

  const {
    data: courseData,
    isLoading: courseIsLoading,
    refetch: refetchCourses,
  } = useQuery(["getCourses", page, debouncedSearch], () => getCourses({
    params: {
      page_size: 8,
      page,
      search: debouncedSearch
    }
  }), {
    keepPreviousData: true,
  })

  const pageDetails = {
    title: "Kurslar",
    desc: `Jami jami soni: (${separateFormatter(courseData?.total_items || 0, " ", "ta")})`,
    buttons: [{
      onClick: () => navigate(URL_COURSES_CREATE),
      text: "Qo'shish",
      icon: "plus-square",
    }]
  };

  const totalItems = courseData?.total_items || 0;
  const itemsPerPage = courseData?.page_size || 8;

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchParams({page: "1", search: query});
  }

  useEffect(() => {
    if (debouncedSearch) {
      refetchCourses();
    }
  }, [debouncedSearch, refetchCourses]);


  return (
      <div>
        <div className="">
          <PageHeader pageDetails={pageDetails}/>
          <div className={"d-flex flex-wrap justify-content-between align-items-center rounded py-1 mb-5"}>
            <div className={"w-100 w-100 w-md-250px"}>
              <div className="d-flex align-items-center position-relative my-1">
                <KTIcon iconName={"magnifier"} className={"fs-1 position-absolute ms-3"}/>

                <input type="text" data-kt-user-table-filter="search"
                       className="form-control w-100 w-md-250px ps-12"
                       placeholder="Qidiruv..." value={searchQuery}
                       onChange={handleSearchChange}/>
              </div>
            </div>
          </div>

          {courseIsLoading ? (
              <LoaderSection height={"50vh"}/>
          ) : !courseData || courseData.data.length === 0 ? (
              <EmptySection height={"50vh"}/>
          ) : (
              <>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-4 g-6 mb-10">
                  {courseData?.data?.map((courseItem) => (
                      <CourseCard refetchCourses={refetchCourses} course={courseItem} key={courseItem?.id}/>
                  ))}
                </div>
                <Pagination
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                />
              </>
          )}
        </div>
      </div>
  )
}

